import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectWithoutProperties from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

var _LINK_GUEST_ENDPOINTS;

var _excluded = ["loginMethod"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Endpoints } from '../../../api/Constants';
import { setAuthorized, setLastLoginInfo } from '../../actions/auth';
import { setModal } from '../../actions/modal';
import Screens from '../../../screens';
import navigation from '../../../utils/navigation/navigation';
import { handleQueryLoggerEvents } from '../../sagas/handleLoggerErrorEvents';
import { validateJson } from '../../../utils/jsonschema/validator';
import { AUTH_TYPES } from '../../../utils/authFlow/constants';
import { setCredentialsOnKeychain } from './utils';
import Utils from '../../../utils';
export var postLinkGuestAccountMutation = {
  query: function query(_ref) {
    var loginMethod = _ref.loginMethod,
        data = _objectWithoutProperties(_ref, _excluded);

    return {
      url: LINK_GUEST_ENDPOINTS[loginMethod],
      body: {
        data: data
      },
      method: 'post'
    };
  },
  transformResponse: function transformResponse(response, meta, _ref2) {
    var loginMethod = _ref2.loginMethod;
    if (validateJson(LINK_GUEST_ENDPOINTS[loginMethod], response, 'POST')) return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3, _ref4) {
      var loginMethod, dispatch, getState, queryFulfilled, lastLoginInfo;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loginMethod = _ref3.loginMethod;
              dispatch = _ref4.dispatch, getState = _ref4.getState, queryFulfilled = _ref4.queryFulfilled;
              lastLoginInfo = getState().token.lastLoginInfo;
              _context.prev = 3;
              _context.next = 6;
              return queryFulfilled;

            case 6:
              dispatch(setAuthorized(true));
              dispatch(setModal(null));
              dispatch(setLastLoginInfo(_objectSpread(_objectSpread({}, lastLoginInfo), {}, {
                loginMethod: loginMethod
              })));
              _context.t0 = Utils.getPlatform() === 'ios';

              if (!_context.t0) {
                _context.next = 13;
                break;
              }

              _context.next = 13;
              return setCredentialsOnKeychain(lastLoginInfo, loginMethod);

            case 13:
              navigation.navigate(Screens.Start);
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t1 = _context["catch"](3);
              handleQueryLoggerEvents(_context.t1);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 16]]);
    }));

    function onQueryStarted(_x, _x2) {
      return _onQueryStarted.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};
var LINK_GUEST_ENDPOINTS = (_LINK_GUEST_ENDPOINTS = {}, _defineProperty(_LINK_GUEST_ENDPOINTS, AUTH_TYPES.MEMBER, Endpoints.LINK_GUEST_ACCOUNT_EMAIL), _defineProperty(_LINK_GUEST_ENDPOINTS, AUTH_TYPES.GOOGLE, Endpoints.LINK_GUEST_ACCOUNT_GOOGLE), _defineProperty(_LINK_GUEST_ENDPOINTS, AUTH_TYPES.APPLE, Endpoints.LINK_GUEST_ACCOUNT_APPLE), _defineProperty(_LINK_GUEST_ENDPOINTS, AUTH_TYPES.FACEBOOK, Endpoints.LINK_GUEST_ACCOUNT_FACEBOOK), _LINK_GUEST_ENDPOINTS);